import halkaBox from "halkabox";
import domready from "domready";

// @deprecated use photoswipe instead
domready(function () {
  var potentialLightBoxElements = document.querySelectorAll(".gallery, .teaser, .textpic, .text-columns, .map, .image-row");
  if (potentialLightBoxElements) {
    Array.prototype.forEach.call(potentialLightBoxElements, function (el) {
      var lightboxID = el.dataset.lightbox || el.dataset.gallery;
      lightboxID && halkaBox.run(lightboxID);
    });
  }
});
